import { render } from "./CIS-TaxonomyItems.vue?vue&type=template&id=4fe198b6"
import script from "./CIS-TaxonomyItems.vue?vue&type=script&lang=js"
export * from "./CIS-TaxonomyItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__